import React from 'react'
import BookForm from './BookForm'
import {Modal} from 'react-bootstrap'


const BookNew = ({show,handleModalClose,handleSubmit,subjects}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Neues Buch</Modal.Title>
        </Modal.Header>
          <BookForm
             handleSubmit={handleSubmit} subjects={subjects}
            />
        </Modal>
  </div>
)

export default BookNew
